/*! hash:06b0d4e8a9e4ea1bc02d, chunkhash:3f226b29555fc711d58d, name:moreActivity/index, filebase:index.3f226b295.js, query:, file:static/js/moreActivity/index.3f226b295.js */
webpackJsonp([7],{

/***/ 12:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__(1);

__webpack_require__(12);

var _global = __webpack_require__(2);

$(function () {
  getNews(1, true);
});

// 获取新闻
window.getNews = function (pageNum, initFlag) {
  var params = {
    pageNum: pageNum,
    pageSize: 6
  };
  $.get(_global.baseUrl + '/api/website/activitys', params, function (data) {
    if (data.errorCode == 0) {
      var dataList = data.data.list;
      var html = '';
      var pages = data.data.pages;
      for (var i = 0; i < dataList.length; i++) {
        dataList[i].introduction = dataList[i].introduction ? dataList[i].introduction : '';
        html += '<li class="list-group-item">' + '<a href="' + dataList[i].infoUrl + '"target="blank"><div class="clearfix">' + '<div class="left">' + '<img src="' + dataList[i].infoPic + '">' + '</div>' + '<div class="right">' + '<h2 class="tit">' + dataList[i].infoHead + '</h2>' + '<p class="time">' + dataList[i].infoPublishTime + '</p>' + '<div class="content">' + dataList[i].introduction + '</div>' + '</div>' + '</div></a>' + '</li>';
      }
      $('#newsWrapper').html(html);
      if (initFlag) {
        var pageHtml = '<li><a onClick="pageChage(1)">&laquo;</a></li>';
        for (var j = 1; j <= pages; j++) {
          if (pageNum == j) {
            pageHtml += '<li class="active" data-page="' + j + '"><a onClick="pageChage(' + j + ')">' + j + '</a></li>';
          } else {
            pageHtml += '<li data-page="' + j + '"><a onClick="pageChage(' + j + ')">' + j + '</a></li>';
          }
        }
        pageHtml += '<li><a onClick="pageChage(' + pages + ')">&raquo;</a></li>';
        $('.pagination-wrapper .pagination').html(pageHtml);
      } else {
        $('.pagination-wrapper .pagination').find('li').each(function () {
          if ($(this).attr('data-page') == pageNum) {
            $(this).addClass('active').siblings().removeClass('active');
          }
        });
      }
    }
  });
};

window.pageChage = function (num) {
  getNews(num, false);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })

},[28]);


// WEBPACK FOOTER //
// static/js/moreActivity/index.3f226b295.js